var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatagram2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Guidelines",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:#FFBADD;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#000894;}\r\n\t.st2{fill:#1D1D1B;}\r\n\t.st3{fill:#2200C9;}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4,3H9.6C6,3,3,6,3,9.6v28.8C3,42,6,45,9.6,45h28.8c3.3,0,6-2.4,6.5-5.6C45,39.3,45,39.1,45,39v-0.1 c0-0.2,0-0.3,0-0.5V9.6C45,6,42,3,38.4,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.7,18.5L39.7,18.5l-4.9,4.9c-0.3,0.3-1.3,0.3-1.6,0c-0.3-0.3-0.3-1.3,0-1.6l2.9-2.9H6 c-0.7,0-1.3-0.7-1.3-1.3c0-0.7,0.7-1.3,1.3-1.3h29.8l-2.9-2.6c-0.3-0.3-0.3-1.3,0-1.6c0.3-0.3,0.7-0.7,1-0.7c0.3,0,0.7,0,1,0.3 l4.9,4.9l0,0c0.3,0.3,0.3,0.7,0.3,1C40.1,17.8,39.7,18.1,39.7,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,31.9H12.2l2.9,2.9c0.3,0.3,0.3,1.3,0,1.6c-0.3,0.3-1.3,0.3-1.6,0l-5.2-4.9l0,0c0-0.3-0.3-0.7-0.3-1 s0-0.7,0.3-1l0,0l4.9-4.9c0.3,0,0.7-0.3,1-0.3s0.7,0,1,0.3c0.3,0.3,0.3,1.3,0,1.6l-2.9,2.9H42c0.7,0,1.3,0.7,1.3,1.3 S42.7,31.9,42,31.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatagram2);
export default __webpack_public_path__ + "static/media/datagram_2.539ddb2245b361943b59df55247803aa.svg";
export { ForwardRef as ReactComponent };